module.exports = __webpack_public_path__ + "img/CTWP__Sword_01.78a89cf0.png";